/*
    Add here your own custom javascript
*/
// flash-sale-timer.js

(function() {
    function updateFlashSaleCountdown() {
        const now = new Date();
        const options = { timeZone: 'Europe/Paris' };
        const parisNow = new Date(now.toLocaleString('en-US', options));
        const nextHour = new Date(parisNow.getFullYear(), parisNow.getMonth(), parisNow.getDate(), parisNow.getHours() + 1, 0, 0, 0);
        const diff = nextHour - parisNow;

        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const countdownElement = document.getElementById('flash-sale-timer-countdown');
        if (countdownElement) {
            countdownElement.innerHTML = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        }
    }

    setInterval(updateFlashSaleCountdown, 1000);
    updateFlashSaleCountdown();
})();

// cart-timer.js

(function() {
    document.addEventListener('DOMContentLoaded', function() {
        function startCartCountdown(duration, display) {
            var timer = duration, minutes, seconds;
            setInterval(function () {
                minutes = parseInt(timer / 60, 10);
                seconds = parseInt(timer % 60, 10);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;

                display.textContent = minutes + ":" + seconds;

                if (--timer < 0) {
                    timer = 0;
                }
            }, 1000);
        }

        var countdownMinutes = 15,
            display = document.querySelector('#cart-timer-display');
        if (display) {
            startCartCountdown(countdownMinutes * 60, display);
        }
    });
})();
